import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import btcIcon from '../assets/coins/btc.png';
import ethIcon from '../assets/coins/eth.png';
import usdtIcon from '../assets/coins/usdt.png';
import usdcIcon from '../assets/coins/usdc.png';

const tokens = [
  { name: 'USDT', icon: usdtIcon },
  { name: 'USDC', icon: usdcIcon },
  { name: 'ETH', icon: ethIcon },
  { name: 'BTC', icon: btcIcon },
];

const UserDeposit = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #ffffff 0%, #ffffff 100%)',
        paddingBottom: '80px',
      }}
    >
      <Container
        fluid
        style={{
          maxWidth: isMobile ? '100%' : '85%',
          padding: 'clamp(1rem, 3vw, 1.5rem)',
        }}
      >
        {/* Header */}
        <div
          className='d-flex align-items-center mb-3 bg-white rounded shadow-sm p-3'
          style={{
            border: '1px solid #e0e0e0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
          }}
        >
          <Link
            to='/assets'
            className='text-dark p-0 me-3'
            style={{
              fontSize: 'clamp(1.3rem, 3vw, 1.5rem)',
              textDecoration: 'none',
            }}
          >
            <i className='bi bi-arrow-left'></i>
          </Link>
          <h5
            className='mb-0'
            style={{
              fontSize: 'clamp(1.15rem, 3vw, 1.3rem)',
              fontWeight: '600',
              color: '#1a1a1a',
            }}
          >
            Deposit
          </h5>
        </div>

        {/* Customer Service */}
        <Link to='/chat' style={{ textDecoration: 'none' }}>
          <Card
            className='mb-3 shadow-sm'
            style={{
              border: '1px solid #e0e0e0',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
              borderRadius: '10px',
            }}
          >
            <div
              className='d-flex justify-content-between align-items-center p-3'
              style={{ cursor: 'pointer' }}
            >
              <div
                style={{
                  fontSize: 'clamp(0.95rem, 2.5vw, 1.05rem)',
                  fontWeight: '500',
                  color: '#333',
                }}
              >
                <i
                  className='bi bi-chat-dots me-2'
                  style={{ color: '#667eea' }}
                ></i>
                Customer Service
              </div>
              <i
                className='bi bi-chevron-right'
                style={{
                  fontSize: 'clamp(1.1rem, 2.5vw, 1.2rem)',
                  color: '#6c757d',
                }}
              ></i>
            </div>
          </Card>
        </Link>

        <p
          className='text-muted mb-3'
          style={{
            fontSize: 'clamp(0.85rem, 2.2vw, 0.9rem)',
            lineHeight: '1.6',
          }}
        >
          <i
            className='bi bi-info-circle me-2'
            style={{ color: '#667eea' }}
          ></i>
          Please fill in the actual amount. Mistakes will lead to system review
          failure and affect the deposit progress.
        </p>

        {/* Token Options */}
        <h6
          className='mb-3'
          style={{
            fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
            fontWeight: '600',
            color: '#1a1a1a',
          }}
        >
          Cryptocurrency
        </h6>
        <Row className='g-3 mb-4'>
          {tokens.map((token) => (
            <Col xs={6} sm={6} md={3} key={token.name}>
              <Link
                to={`/deposit/${token.name.toLowerCase()}`}
                style={{ textDecoration: 'none' }}
              >
                <div
                  className='bg-white rounded shadow-sm text-center p-3'
                  style={{
                    border: '1px solid #e0e0e0',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                    cursor: 'pointer',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow =
                      '0 6px 20px rgba(102, 126, 234, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow =
                      '0 2px 8px rgba(0,0,0,0.05)';
                  }}
                >
                  <div
                    style={{
                      marginBottom: '8px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <img
                      src={token.icon}
                      alt={token.name}
                      style={{
                        width: 'clamp(2.5rem, 6vw, 3rem)',
                        height: 'clamp(2.5rem, 6vw, 3rem)',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                  <div
                    style={{
                      fontSize: 'clamp(0.95rem, 2.5vw, 1.05rem)',
                      fontWeight: '600',
                      color: '#333',
                    }}
                  >
                    {token.name}
                  </div>
                </div>
              </Link>
            </Col>
          ))}
        </Row>

        {/* Third-party channels */}
        <h6
          className='mb-3'
          style={{
            fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
            fontWeight: '600',
            color: '#1a1a1a',
          }}
        >
          Third-party official recharge channel
        </h6>
        <Row className='g-3'>
          <Col xs={12} sm={6}>
            <div
              className='bg-dark text-white rounded shadow-sm p-3'
              style={{
                cursor: 'pointer',
                transition: 'transform 0.2s',
                fontSize: 'clamp(0.9rem, 2.2vw, 0.95rem)',
                fontWeight: '500',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = 'translateY(-2px)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = 'translateY(0)')
              }
            >
              ⚫ crypto.com
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <div
              className='bg-warning text-dark rounded shadow-sm p-3'
              style={{
                cursor: 'pointer',
                transition: 'transform 0.2s',
                fontSize: 'clamp(0.9rem, 2.2vw, 0.95rem)',
                fontWeight: '500',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = 'translateY(-2px)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = 'translateY(0)')
              }
            >
              BINANCE official deposit channel
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <div
              className='bg-dark text-white rounded shadow-sm p-3'
              style={{
                cursor: 'pointer',
                transition: 'transform 0.2s',
                fontSize: 'clamp(0.9rem, 2.2vw, 0.95rem)',
                fontWeight: '500',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = 'translateY(-2px)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = 'translateY(0)')
              }
            >
              🟩 changelly
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <div
              className='bg-primary text-white rounded shadow-sm p-3'
              style={{
                cursor: 'pointer',
                transition: 'transform 0.2s',
                fontSize: 'clamp(0.9rem, 2.2vw, 0.95rem)',
                fontWeight: '500',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = 'translateY(-2px)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = 'translateY(0)')
              }
            >
              CoinCola official deposit channel
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <div
              className='bg-white text-dark rounded shadow-sm p-3'
              style={{
                cursor: 'pointer',
                transition: 'transform 0.2s',
                fontSize: 'clamp(0.9rem, 2.2vw, 0.95rem)',
                fontWeight: '500',
                border: '1px solid #e0e0e0',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = 'translateY(-2px)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = 'translateY(0)')
              }
            >
              ⚪ MoonPay.com
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <div
              className='bg-white text-dark rounded shadow-sm p-3'
              style={{
                cursor: 'pointer',
                transition: 'transform 0.2s',
                fontSize: 'clamp(0.9rem, 2.2vw, 0.95rem)',
                fontWeight: '500',
                border: '1px solid #e0e0e0',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = 'translateY(-2px)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = 'translateY(0)')
              }
            >
              OKEX official deposit channel
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <div
              className='bg-white text-dark rounded shadow-sm p-3'
              style={{
                cursor: 'pointer',
                transition: 'transform 0.2s',
                fontSize: 'clamp(0.9rem, 2.2vw, 0.95rem)',
                fontWeight: '500',
                border: '1px solid #e0e0e0',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = 'translateY(-2px)')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = 'translateY(0)')
              }
            >
              🟢 simplex
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UserDeposit;
